import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const monitoringIssueDocumentsApi = {
    getMonitoringIssueDocuments: (): Observable<Dtos.GetMonitoringIssueDocumentsResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssueDocuments = new Dtos.GetMonitoringIssueDocuments();

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssueDocumentsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringIssueDocumentsByMonitoringIssueId: (monitoringIssueId: number): Observable<Dtos.GetMonitoringIssueDocumentsByMonitoringIssueIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssueDocumentsByMonitoringIssueId = new Dtos.GetMonitoringIssueDocumentsByMonitoringIssueId();

        request.monitoringIssueId = monitoringIssueId;

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssueDocumentsByMonitoringIssueIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitoringIssueDocumentById: (id: number): Observable<Dtos.GetMonitoringIssueDocumentByIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitoringIssueDocumentById = new Dtos.GetMonitoringIssueDocumentById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetMonitoringIssueDocumentByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setMonitoringIssueDocument: (monitoringIssueDocument: Dtos.MonitoringIssueDocument): Observable<Dtos.SetMonitoringIssueDocumentResponse> => {

        let request: Dtos.SetMonitoringIssueDocument = new Dtos.SetMonitoringIssueDocument();

        request.monitoringIssueDocument = monitoringIssueDocument;

        // send request
        const response: Promise<Dtos.SetMonitoringIssueDocumentResponse> = client.post(request);

        return Observable.from(response);
    },
    createMonitoringIssueDocument: (monitoringIssueId: number): Observable<Dtos.CreateMonitoringIssueDocumentResponse> => {
        //Create the request.
        let request: Dtos.CreateMonitoringIssueDocument = new Dtos.CreateMonitoringIssueDocument();

        request.monitoringIssueId = monitoringIssueId;

        //Send request.
        const response: Promise<Dtos.CreateMonitoringIssueDocumentResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateMonitoringIssueDocument: (monitoringIssueDocument: Dtos.MonitoringIssueDocument): Observable<Dtos.ValidateMonitoringIssueDocumentResponse> => {

        let request: Dtos.ValidateMonitoringIssueDocument = new Dtos.ValidateMonitoringIssueDocument();

        request.monitoringIssueDocument = monitoringIssueDocument;

        // send request
        const response: Promise<Dtos.ValidateMonitoringIssueDocumentResponse> = client.post(request);

        return Observable.from(response);
    }
}